import { DureeCalculee } from '../../modules/NouvelleDemande/NouvelleDemande.types'
import { axiosInstance } from '../Middleware'
import { Absence } from './types'

export class AbsenceApi {
  public static loadAbsence = (identifiantAgent: number, dateDebut: string, dateFin: string) : Promise<Absence[]> =>
    axiosInstance.get(`/personnel/personnel/absences?identifiantAgent=${identifiantAgent}&withNatureAbsence=true&dateRefDebut=${dateDebut}&dateRefFin=${dateFin}&perPage=400`)
      .then(response => response.data.data)

  public static getDuree = (complement?: string) : Promise<DureeCalculee> =>
    axiosInstance.get(`/personnel/personnel/absences/dureeCalculee${complement ? `?${complement}` : ''}`)
      .then(response => response.data)
}
